import { inject, Injectable } from '@angular/core';
import { MatSnackBar, MatSnackBarRef } from '@angular/material/snack-bar';
import { TranslocoService } from '@jsverse/transloco';

import { BiSnackbar } from '../../ui/snackbar/snackbar';
import type { SnackbarVariant } from '../../types/interfaces/ui/snackbar/snackbar-variant';

const SNACKBAR_DURATION_MS = 3000;

const PANEL_CLASS: Record<SnackbarVariant, string> = {
  error: 'app-snackbar--error',
  success: 'app-snackbar--success',
  info: 'app-snackbar--info',
};

@Injectable({
  providedIn: 'root',
})
export class SnackbarService {
  private readonly snackBar = inject(MatSnackBar);
  private readonly transloco = inject(TranslocoService);

  showError(message: string): MatSnackBarRef<BiSnackbar> {
    return this.open(message || this.transloco.translate('Something went wrong'), 'error');
  }

  showSuccess(message: string): MatSnackBarRef<BiSnackbar> {
    return this.open(message, 'success');
  }

  showInfo(message: string): MatSnackBarRef<BiSnackbar> {
    return this.open(message, 'info');
  }

  private open(message: string, variant: SnackbarVariant): MatSnackBarRef<BiSnackbar> {
    return this.snackBar.openFromComponent(BiSnackbar, {
      data: { message, variant },
      duration: SNACKBAR_DURATION_MS,
      horizontalPosition: 'end',
      verticalPosition: 'top',
      panelClass: [PANEL_CLASS[variant]],
      politeness: variant === 'error' ? 'assertive' : 'polite',
    });
  }
}
